const MINUTE = 60;
const STUNDE = 60 * MINUTE;
const TAG = 24 * STUNDE;

/**
 * Staffelt die Restzeit nach Groessenordnung (Thomas, 2026-08-09):
 * erst Tage, dann Stunden, dann Minuten sobald weniger als eine Stunde bleibt.
 *
 * Vorher stand hier HH:MM:SS. Bei der Frist von acht Wochen las sich das als
 * "1344:00:00" — eine Zahl, die niemand in Wochen umrechnet.
 *
 * 🔴 Es wird ABGERUNDET. Aus "1 Tag und 23 Stunden" werden nicht "2 Tage":
 * die Anzeige darf nie mehr Zeit versprechen, als der Vorgang noch hat.
 *
 * @param {number} seconds verbleibende Sekunden, nie negativ
 * @returns {{value: (number|null), id: string, fallback: string}}
 *   `value` ist die Zahl vor dem Einheitentext, oder null in der letzten
 *   Minute, die ohne Zahl auskommt.
 */
export const formatRemainingTime = (seconds) => {
  // ⛔ KEIN eigener Text für "Frist abgelaufen" (Thomas, 2026-08-09): ist die
  // Frist um, ist der Vorgang vollzogen -- dann gibt es den Datensatz nicht
  // mehr und die Person kann sich gar nicht mehr anmelden, um einen Bildschirm
  // zu sehen. Der Zustand ist im Zielbild unerreichbar.
  // ⚠️ Solange P5 den Vollzug NICHT auslöst, stimmt das nicht: ein Vorgang,
  // dessen Frist verstreicht, bleibt offen, die Person bleibt anmeldbar und
  // sieht dann dauerhaft "weniger als eine Minute". Das ist der Preis dieser
  // Entscheidung und der Grund, warum P5 vor Ablauf der ersten Frist stehen
  // muss -- also binnen acht Wochen nach dem ersten echten Auslösen.
  if (seconds >= TAG) {
    const days = Math.floor(seconds / TAG);
    return days === 1
      ? { value: 1, id: 'pseudonymization-day', fallback: 'Tag' }
      : { value: days, id: 'pseudonymization-days', fallback: 'Tage' };
  }
  if (seconds >= STUNDE) {
    const hours = Math.floor(seconds / STUNDE);
    return hours === 1
      ? { value: 1, id: 'pseudonymization-hour', fallback: 'Stunde' }
      : { value: hours, id: 'pseudonymization-hours', fallback: 'Stunden' };
  }
  if (seconds >= MINUTE) {
    const minutes = Math.floor(seconds / MINUTE);
    return minutes === 1
      ? { value: 1, id: 'pseudonymization-minute', fallback: 'Minute' }
      : { value: minutes, id: 'pseudonymization-minutes', fallback: 'Minuten' };
  }
  // Bewusst nicht "0 Minuten": die letzte Minute laeuft, sie ist nicht vorbei.
  return {
    value: null,
    id: 'pseudonymization-less-than-a-minute',
    fallback: 'weniger als eine Minute',
  };
};

export default formatRemainingTime;
